export enum TemplateChannels {
  Email = 'email',
  SMS = 'sms',
}

export class TemplateModel {
  blob: string;
  exampleDataBlob: string;
  channel: string;
  rawTemplate: string;
  rawExampleData: object | null;
}
